import React from 'react';

import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import styled from 'styled-components';

import { toStringSet } from '../../utils/assets';
import { Component as GridStencil } from '../GridStencil';
import { Component as ProductCell } from '../ProductCell';
import { Component as ProductGrid } from '../ProductGridOld';
import { Component as Products } from '../Products';
import { Component as TemplateCaptionCarousel } from '../TemplateCaptionCarousel';

const Wrapper = styled.div`
  ${TemplateCaptionCarousel.Wrapper} + ${ProductCell.Container} + ${ProductCell.Container} + ${ProductCell.Container} + ${ProductCell.Container} + ${ProductCell.Container} {
    clear: both;
  }
`;

function FplsAsset({
  additionalParams,
  additionalProduct,
  applyUserSizes = true,
  asset,
  assetSlots = null,
  breakpoints,
  className,
  children,
  onLoadedProducts,
  pSource,
  shouldCategorize = false,
  sizeLimit: sizeLimitFromProps,
}) {
  const sizeLimit =
    sizeLimitFromProps ||
    asset.options.customVars.fplProductsCount ||
    asset.options.customVars.fplSizeLimit;

  const fplsId = asset.options.customVars.fpl;

  // In order to know what type of grid we're rendering in order to safely
  // apply profile size filters, require that assets specify via their type
  // `categoryFilters`.
  let sections = { bras: true, undies: true, lingerie: true };

  if (asset.options.customVars.flags) {
    const flags = toStringSet(asset.options.customVars.flags, true);
    sections = {
      bras: flags.has('bras'),
      undies: flags.has('undies'),
      lingerie: flags.has('lingerie'),
    };
  } else if (asset.options.customVars.categoryFilters) {
    const categoryFilters = toStringSet(
      asset.options.customVars.categoryFilters,
      true
    );
    sections = {
      bras: categoryFilters.has('bras'),
      undies: categoryFilters.has('undies'),
      lingerie: categoryFilters.has('lingerie'),
    };
  }

  const pageLimit = Math.ceil(parseInt(sizeLimit, 10) / 28);

  return (
    <Wrapper className={className}>
      <Products
        filters={{
          fpls: fplsId,
          sections,
          includeXclusive: true,
          categorized: shouldCategorize,
          ...additionalParams,
        }}
        applyUserSizes={applyUserSizes}
        onLoadedProducts={onLoadedProducts}
        pageLimit={pageLimit}
        shouldCategorize={shouldCategorize}
        render={({
          hasNextPage,
          loading,
          loadPage,
          products,
          refinements,
          storeKey,
        }) => {
          const fplProducts = additionalProduct
            ? [additionalProduct, ...products]
            : products;

          return (
            <InfiniteScroll
              key={storeKey}
              hasMore={hasNextPage}
              initialLoad={false}
              loadMore={loadPage}
              pageStart={1}
              threshold={387}
              useWindow
            >
              <ProductGrid
                assetSlots={assetSlots}
                asset={asset}
                breakpoints={breakpoints}
                pSource={pSource}
                products={fplProducts}
                sizeLimit={sizeLimit || 7}
              >
                {loading ? (
                  <GridStencil
                    assetSlots={assetSlots}
                    slotCount={sizeLimit || 6}
                  />
                ) : null}
                {children}
              </ProductGrid>
            </InfiniteScroll>
          );
        }}
      />
    </Wrapper>
  );
}

FplsAsset.propTypes = {
  additionalParams: PropTypes.object,
  applyUserSizes: PropTypes.bool,
  asset: PropTypes.object.isRequired,
  assetSlots: PropTypes.object,
  breakpoints: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node,
  onLoadedProducts: PropTypes.func,
  sizeLimit: PropTypes.number,
  pSource: PropTypes.string,
  additionalProduct: PropTypes.object,
  shouldCategorize: PropTypes.bool,
};

export default FplsAsset;
